// NOTE(apoorvyadav1|SPD-15743|2026-08-13): Base64-encode the tag path so CloudFront WAF's
// SQLi rule does not 403 requests where the path contains ' -- ' (the SQL comment marker).
// The 'b64:' prefix explicitly signals the new format to logic-flow-web — anything without
// the prefix is treated as legacy plaintext (allows unmigrated producers to keep working).
// The prefix is a permanent part of the URL contract; no follow-up cleanup required.
// Same rationale as SPD-15333, which moved partnerTags/isAutoTaggingAvailable to POST body.
const textEncoder = new TextEncoder();

// Avoids String.fromCharCode(...bytes), which crashes on inputs above the per-engine
// function-argument limit (~65K on V8). Array.from + join is O(n) — reduce with string
// concatenation is O(n²) in the underlying spec, even though modern engines optimize with ropes.
const bytesToBinaryString = (bytes) => Array.from(bytes, (byte) => String.fromCharCode(byte)).join('');

export const encodeMacroWizardTagPath = (value) =>
  value ? `b64:${btoa(bytesToBinaryString(textEncoder.encode(value)))}` : value;
